<template>
  <div class="transparent-tab">
    <a-input
      v-model="value"
      :placeholder="$t('请输入关键字查询')"
      style="width: 100%"
      allowClear
      @change="handleSearch"
    ></a-input>
    <div class="search" v-if="JSON.stringify(list) != '{}'&&value">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" :header="$t('节点')">
          <a-list item-layout="horizontal" :data-source="list.nodeList">
            <a-list-item slot="renderItem" slot-scope="item" @click="handleClick(item)">
              <p>{{ $t('名称：') }}{{ item.name }}</p>
              <p>{{ $t('编码：') }}{{ item.code}}</p>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
        <a-collapse-panel key="2" :header="$t('管道')">
          <a-list item-layout="horizontal" :data-source="list.pipelineList">
            <a-list-item slot="renderItem" slot-scope="item" @click="handleClick(item)">
              <p>{{ $t('名称：') }}{{ item.name }}</p>
              <p>{{ $t('编码：') }}{{ item.code}}</p>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
        <a-collapse-panel key="3" :header="$t('区域')">
          <a-list item-layout="horizontal" :data-source="list.areaList">
            <a-list-item slot="renderItem" slot-scope="item" @click="handleClick(item)">
              <p>{{ $t('名称：') }}{{ item.name }}</p>
              <p>{{ $t('编码：') }}{{ item.code}}</p>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>
      
  <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JInput from '../../../../components/jeecg/JInput.vue'
import Vue from 'vue'
export default {
  name: 'modal',
  components: {
    JInput,
  },
  data() {
    return {
      title: this.$t('组件0'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      url: {
        list: '/jeecg-gis/topology/topology/listTopologyMemberInfo',
      },
      activeKey: '1',
      versionForm: {},
      list: {},
      value: ''
    }
  },
  created() {
    this.versionForm = Vue.ls.get('GIS_TOPOLOGY_DATA').topology
  },
  methods: {
    getData(value) {
      let params = {
        projectCode: this.versionForm.projectCode,
        topologyCode: this.versionForm.code,
        value: value,
      }
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          this.list = res.result;
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleSearch(e) {
      this.getData(e.target.value)
    },
    handleClick(item) {
      this.$emit('change',item);
    },
  },
}
</script>
  <style lang="less" scoped>
.transparent-tab {
  width: 300px;
  position: absolute;
  z-index: 100;
  top: 10px;
  left: 10px;
}
::v-deep .ant-input {
  background-color: rgba(70, 76, 92, 0.8);
  border-color: rgba(70, 76, 92, 0.8);
  color: #fff;
}
::v-deep .ant-collapse{
  background-color: rgba(70, 76, 92, 0.8);
  border-color: rgba(70, 76, 92, 0.8);
}
::v-deep .ant-collapse > .ant-collapse-item{
  border-color: rgba(70, 76, 92, 0.8);
}
::v-deep .ant-collapse > .ant-collapse-item > .ant-collapse-header,::v-deep .ant-list{
  color: #fff;
}
::v-deep .ant-collapse-content{
  background-color: rgba(70, 76, 92, 0.8);
  color: #fff;
}
::v-deep .ant-collapse > .ant-collapse-item > .ant-collapse-header{
  padding: 5px 0 5px 40px;
}
::v-deep .ant-empty-normal{
  margin: 0;
}
::v-deep .ant-collapse-content > .ant-collapse-content-box{
  padding: 10px;
  max-height: 150px;
  overflow: auto;
}
::v-deep .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled){
  border-color: rgba(70, 76, 92, 0.8);
}
.ant-list-item{
  display: block;
  cursor: pointer;
  padding: 5px 0;
  p{
    margin-bottom: 0;
  }
}
</style>